'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'pen-to-square';
var width = 576;
var height = 512;
var aliases = ["edit"];
var unicode = 'f044';
var svgPathData = 'M160 384c2.3-12.4 10.3-55.1 24-128L433.4 6.6 456-16c9.1 9.1 36.2 36.2 81.4 81.4L560 88 537.4 110.6 288 360c-72.9 13.7-115.6 21.7-128 24zm112.4-53.6l169.7-169.7-58.7-58.7-169.7 169.7-13.6 72.3 72.3-13.6zM464.7 138.1l50.1-50.1-58.7-58.7-50.1 50.1 58.7 58.7zM32 64l224 0 0 32-192 0 0 384 384 0 0-192 32 0 0 224-448 0 0-448z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPenToSquare = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;